export default __webpack_public_path__ + "static/media/cashflow-checkout-icon.056443dd.svg";